import { useState } from 'react';
import { Button, Container, TextField, Box, Typography } from '@mui/material';
import { t } from 'i18next';

function DividiTotaleComanda({ totaleComanda = 0, onClose }) {
  const [numeroDivisioni, setNumeroDivisioni] = useState(1);
  const [splitResult, setSplitResult] = useState(null);

  const handleDividi = () => {
    const split = totaleComanda / numeroDivisioni;
    setSplitResult({
      amountPerPerson: split.toFixed(2),
      total: totaleComanda.toFixed(2),
    });
  };

  return (
    <Container>
      <Box display="flex" flexDirection="column" gap={2}>
        <Typography variant="h6">
          {splitResult
            ? `${splitResult.amountPerPerson}€ ${t("perPerson")} (Tot: ${splitResult.total}€)`
            : `${t("total")} : ${totaleComanda.toFixed(2)}€`}
        </Typography>
        <Box display="flex" alignItems="center" gap={2}>
          <TextField
            type="number"
            label={t("numberOfPeople")}
            size="small"
            inputProps={{ min: 1 }}
            value={numeroDivisioni}
            onChange={(e) => setNumeroDivisioni(parseInt(e.target.value) || 1)}
            sx={{ width: 120 }}
          />
          <Button variant="contained" onClick={handleDividi}>
            {t("split")}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default DividiTotaleComanda;
